import React from 'react';
import { motion } from 'framer-motion';
import { InfinityIcon, DownloadIcon, WifiOffIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
const perks = [{
  icon: InfinityIcon,
  text: 'Un solo pago, acceso para siempre'
}, {
  icon: DownloadIcon,
  text: 'Descargá todo en tu celu o compu'
}, {
  icon: WifiOffIcon,
  text: 'Tejé incluso sin internet'
}];
export function Pricing() {
  return <section id="comprar" className="scroll-mt-16 bg-cream py-16 sm:py-24" aria-labelledby="price-title" data-id="element-143" data-mp="1vublwkleg94x">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-144" data-mp="1rujc64k9rwxz">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-145" data-mp="25t94z8023agj">
          Precio de lanzamiento
        </span>
        <h2 id="price-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-146" data-mp="20v7o8tq3rn88">
          Queremos que el arte del amigurumi llegue a cada rincón
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg text-muted" data-id="element-147" data-mp="3c81tw2fn3hju">
          Por eso, si te sumás hoy, no vas a pagar $27.500.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 22
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.5
      }} className="mt-10 rounded-[2rem] border-2 border-terracotta bg-white p-8 shadow-soft sm:p-12" data-id="element-148" data-mp="4svvdoosx0sc">
          <p className="text-lg font-semibold text-muted line-through" data-id="element-149" data-mp="3daa6ft5g5v79">$27.500 ARS</p>
          <p className="mt-1 text-sm font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-150" data-mp="3i791qf0uk871">
            Hoy solo
          </p>
          <p className="mt-2 font-display text-6xl font-black leading-none text-ink sm:text-7xl" data-id="element-151" data-mp="3n5kasnjbieo7">
            $11.990
            <span className="ml-2 align-middle text-xl font-bold text-muted" data-id="element-152" data-mp="3rzy9ozx6v3xm">ARS</span>
          </p>

          <div className="mx-auto mt-8 max-w-sm rounded-2xl bg-cream p-6" data-id="element-153" data-mp="2ugdb3l84nj1d">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-154" data-mp="2zfzqa07in9ct">
              El precio de $11.990 termina en
            </p>
            <div className="mt-4" data-id="element-155" data-mp="2mi1jndv0nr9v">
              <Countdown data-id="element-156" data-mp="2mh08zahwx6so" />
            </div>
            <p className="mt-4 text-sm text-muted" data-id="element-157" data-mp="2mfxhb0crn0bp">
              Cuando el reloj llegue a cero, la página vuelve al precio de $27.500.
            </p>
          </div>

          <div className="stitch-divider mx-auto my-8 max-w-xs" aria-hidden="true" data-id="element-158" data-mp="2w83agder7nsh" />

          <ul className="mx-auto grid max-w-lg gap-3 text-left sm:grid-cols-3 sm:text-center" data-id="element-159" data-mp="28is7cp9xlhb6">
            {perks.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-center gap-3 sm:flex-col sm:gap-2" data-id="element-160" data-mp="2igptn788d415">
                <Icon className="h-5 w-5 shrink-0 text-terracotta" aria-hidden="true" data-id="element-161" data-mp="2dhd6smhczwyk" />
                <span className="text-sm font-semibold text-ink" data-id="element-162" data-mp="3tvbqhsvzk4n3">{text}</span>
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-163" data-mp="3owin4taexu0n">
            <CtaButton subLabel="Compra 100% segura · Acceso inmediato por mail" data-id="element-164" data-mp="3ov7as52wjdxx" />
          </div>
        </motion.div>
      </div>
    </section>;
}